export const storageDbConfig = {
  version: 1,
  name: 'govapp',
  tables: {
    offlineUsers: '++id,email,guest,data',
  },
};
